import React, { Fragment } from 'react';
export function VSLTestimonials() {
  const testimonials = [{
    quote: 'Sent 1,652 offers. Got 2 contracts. Closed one for $12,000.',
    author: 'Chicago Investor',
    highlight: '$12,000'
  }, {
    quote: 'First MLS deal I’ve ever wholesaled. The volume just works.',
    author: 'Florida Creative Investor',
    highlight: 'First MLS deal'
  }, {
    quote: 'I don’t even open the MLS anymore. The offers just go out.',
    author: 'Arizona Flipper',
    highlight: 'don’t even open'
  }];
  return <section className="w-full bg-[#0f0f0f] py-24 px-4 sm:px-6 lg:px-8 border-t border-white/5" data-id="element-2533">
      <div className="max-w-6xl mx-auto" data-id="element-2534">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2535">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1a1a1a] p-8 rounded-2xl border border-white/5 relative" data-id="element-2536">
              <div className="text-4xl text-[#3ab795] opacity-20 absolute top-4 left-4 font-serif" data-id="element-2537">
                "
              </div>
              <p className="text-white text-lg font-medium mb-6 relative z-10 pt-4" data-id="element-2538">
                {t.quote.split(t.highlight).map((part, idx, arr) => <Fragment key={idx} data-id="element-2539">
                    {part}
                    {idx < arr.length - 1 && <span className="text-[#3ab795] font-bold bg-[#3ab795]/10 px-1 rounded" data-id="element-2540">
                        {t.highlight}
                      </span>}
                  </Fragment>)}
              </p>
              <div className="flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-2541">
                <div className="w-10 h-10 bg-gradient-to-br from-gray-700 to-gray-800 rounded-full flex items-center justify-center text-xs font-bold text-white/50" data-id="element-2542">
                  {t.author.charAt(0)}
                </div>
                <span className="text-[#b8bcc8] font-medium text-sm uppercase tracking-wide" data-id="element-2543">
                  {t.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}